// extracted by mini-css-extract-plugin
export default {"container":"ColumnContainer_container__jQ4GL","column":"ColumnContainer_column__447lq"};